import Initialiser from 'initialiser';
import store from 'ducks/configureStore';
import { addItem, removeItem } from 'utils/immutable';

// ACTION TYPES
const START_FETCH_USER = 'START_FETCH_USER';
const STOP_FETCH_USER = 'STOP_FETCH_USER';
const USER_LOGIN = 'USER_LOGIN';
const START_RECOVER_PASSWORD = 'START_RECOVER_PASSWORD';
const STOP_RECOVER_PASSWORD = 'STOP_RECOVER_PASSWORD';
const START_FETCH_WORKS = 'START_FETCH_WORKS';
const UPDATED_WORKS = 'UPDATED_WORKS';
const START_FETCH_WORK_STATS = 'START_FETCH_WORK_STATS';
const UPDATED_WORK_STATS = 'UPDATED_WORK_STATS';
const START_FETCH_WORK_METADATA = 'START_FETCH_WORK_METADATA';
const UPDATED_WORK_METADATA = 'UPDATED_WORK_METADATA';
const START_FETCH_WORK_RECORDINGS = 'START_FETCH_WORK_RECORDINGS';
const UPDATED_WORK_RECORDINGS = 'UPDATED_WORK_RECORDINGS';
const START_FETCH_WORK_DETAILS = 'START_FETCH_WORK_DETAILS';
const UPDATED_WORK_DETAILS = 'UPDATED_WORK_DETAILS';
const START_FETCH_DASHBOARD_SUMMARY = 'START_FETCH_DASHBOARD_SUMMARY';
const UPDATED_DASHBOARD_SUMMARY = 'UPDATED_DASHBOARD_SUMMARY';
const START_FETCH_DASHBOARD_SUMMARY_DELTA = 'START_FETCH_DASHBOARD_SUMMARY_DELTA';
const UPDATED_DASHBOARD_SUMMARY_DELTA = 'UPDATED_DASHBOARD_SUMMARY_DELTA';
const START_FETCH_DASHBOARD_ACTIONS = 'START_FETCH_DASHBOARD_ACTIONS';
const UPDATED_DASHBOARD_ACTIONS = 'UPDATED_DASHBOARD_ACTIONS';
const START_FETCH_DASHBOARD_MATCHING = 'START_FETCH_DASHBOARD_MATCHING';
const UPDATED_DASHBOARD_MATCHING = 'UPDATED_DASHBOARD_MATCHING';
const START_FETCH_PERFORMANCE_CHARTS = 'START_FETCH_PERFORMANCE_CHARTS';
const UPDATED_PERFORMANCE_CHARTS = 'UPDATED_PERFORMANCE_CHARTS';
const START_FETCH_PERFORMANCE_TOP_SONGS = 'START_FETCH_PERFORMANCE_TOP_SONGS';
const UPDATED_PERFORMANCE_TOP_SONGS = 'UPDATED_PERFORMANCE_TOP_SONGS';
const START_FETCH_PERFORMANCE_MARKET_SHARE = 'START_FETCH_PERFORMANCE_MARKET_SHARE';
const UPDATED_PERFORMANCE_MARKET_SHARE = 'UPDATED_PERFORMANCE_MARKET_SHARE';
const START_FETCH_PERFORMANCE_RANKINGS = 'START_FETCH_PERFORMANCE_RANKINGS';
const UPDATED_PERFORMANCE_RANKINGS = 'UPDATED_PERFORMANCE_RANKINGS';
const START_FETCH_INBOX = 'START_FETCH_INBOX';
const UPDATED_INBOX = 'UPDATED_INBOX';
const START_FETCH_ROYALTIES = 'START_FETCH_ROYALTIES';
const UPDATED_ROYALTIES = 'UPDATED_ROYALTIES';
const START_FILE_STATUS_UPDATE = 'START_FILE_STATUS_UPDATE';
const UPDATED_FILE_STATUS = 'UPDATED_FILE_STATUS';

// SYNC ACTION CREATORS
export function startFetchUser() {
    return { type: START_FETCH_USER };
}
export function stopFetchUser() {
    return { type: STOP_FETCH_USER };
}
export function startRecoverPassword() {
    return { type: START_RECOVER_PASSWORD };
}
export function stopRecoverPassword() {
    return { type: STOP_RECOVER_PASSWORD };
}

// ASYNC ACTION CREATORS

// SELECTORS
export function selectFetching() {
    return store.getState().fetching;
}

// REDUCER
export default function reducer(state = Initialiser.initialState.fetching, action) {
    switch (action.type) {
        case START_FETCH_USER:
            return addItem(state, 'user');
        case STOP_FETCH_USER:
        case USER_LOGIN:
            return removeItem(state, 'user');
        case START_RECOVER_PASSWORD:
            return addItem(state, 'recover_password');
        case STOP_RECOVER_PASSWORD:
            return removeItem(state, 'recover_password');
        case START_FETCH_WORKS:
            return addItem(state, 'works');
        case UPDATED_WORKS:
            return removeItem(state, 'works');
        case START_FETCH_WORK_STATS:
            return addItem(state, 'work_stats');
        case UPDATED_WORK_STATS:
            return removeItem(state, 'work_stats');
        case START_FETCH_WORK_METADATA:
            return addItem(state, 'work_metadata');
        case UPDATED_WORK_METADATA:
            return removeItem(state, 'work_metadata');
        case START_FETCH_WORK_RECORDINGS:
            return addItem(state, 'work_recordings');
        case UPDATED_WORK_RECORDINGS:
            return removeItem(state, 'work_recordings');
        case START_FETCH_WORK_DETAILS:
            return addItem(state, 'work_details');
        case UPDATED_WORK_DETAILS:
            return removeItem(state, 'work_details');
        case START_FETCH_DASHBOARD_SUMMARY:
            return addItem(state, 'dashboard_summary');
        case UPDATED_DASHBOARD_SUMMARY:
            return removeItem(state, 'dashboard_summary');
        case START_FETCH_DASHBOARD_SUMMARY_DELTA:
            return addItem(state, 'dashboard_summary_delta');
        case UPDATED_DASHBOARD_SUMMARY_DELTA:
            return removeItem(state, 'dashboard_summary_delta');
        case START_FETCH_DASHBOARD_ACTIONS:
            return addItem(state, 'dashboard_actions');
        case UPDATED_DASHBOARD_ACTIONS:
            return removeItem(state, 'dashboard_actions');
        case START_FETCH_DASHBOARD_MATCHING:
            return addItem(state, 'dashboard_matching');
        case UPDATED_DASHBOARD_MATCHING:
            return removeItem(state, 'dashboard_matching');
        case START_FETCH_PERFORMANCE_CHARTS:
            return addItem(state, 'performance_charts');
        case UPDATED_PERFORMANCE_CHARTS:
            return removeItem(state, 'performance_charts');
        case START_FETCH_PERFORMANCE_TOP_SONGS:
            return addItem(state, 'top_songs');
        case UPDATED_PERFORMANCE_TOP_SONGS:
            return removeItem(state, 'top_songs');
        case START_FETCH_PERFORMANCE_MARKET_SHARE:
            return addItem(state, 'market_share');
        case UPDATED_PERFORMANCE_MARKET_SHARE:
            return removeItem(state, 'market_share');
        case START_FETCH_PERFORMANCE_RANKINGS:
            return addItem(state, 'rankings');
        case UPDATED_PERFORMANCE_RANKINGS:
            return removeItem(state, 'rankings');
        case START_FETCH_INBOX:
            return addItem(state, 'inbox');
        case UPDATED_INBOX:
            return removeItem(state, 'inbox');
        case START_FETCH_ROYALTIES:
            return addItem(state, 'royalties');
        case UPDATED_ROYALTIES:
            return removeItem(state, 'royalties');
        case START_FILE_STATUS_UPDATE:
            return addItem(state, 'file_status');
        case UPDATED_FILE_STATUS:
            return removeItem(state, 'file_status');
        default:
            return state;
    }
}
